var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "padding": "0 4px"
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "clipped": _vm.primaryDrawer.clipped,
      "floating": _vm.primaryDrawer.floating,
      "mini-variant": _vm.primaryDrawer.mini,
      "permanent": _vm.primaryDrawer.type === 'permanent',
      "temporary": _vm.primaryDrawer.type === 'temporary',
      "app": "",
      "overflow": ""
    },
    model: {
      value: _vm.primaryDrawer.model,
      callback: function callback($$v) {
        _vm.$set(_vm.primaryDrawer, "model", $$v);
      },
      expression: "primaryDrawer.model"
    }
  }, [_c('div', {
    staticClass: "pa-2 pl-4 pt-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.appLogoUrl,
      "width": "140",
      "alt": "CRM"
    }
  })]), _c('v-divider'), _c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [false ? _c('v-list-item-avatar', [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/81.jpg",
      "alt": "Аватар"
    }
  })]) : _vm._e(), _c('v-list-item-content', [_c('v-list-item-title', {
    attrs: {
      "data-test": "nav-user-name"
    }
  }, [_vm._v(_vm._s(_vm.user.fullName))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.user.roleDesc))]), _c('div', {
    staticClass: "pt-2"
  }, [_c('v-btn', {
    attrs: {
      "data-test": "nav-logout",
      "color": "error",
      "outlined": "",
      "x-small": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Выйти")])], 1)], 1)], 1), _c('v-divider'), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l(_vm.userMenu, function (menu) {
    return [menu.children ? _c('v-list-group', {
      key: menu.title,
      attrs: {
        "prepend-icon": menu.icon,
        "no-action": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn() {
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(menu.title))])], 1)];
        },
        proxy: true
      }], null, true)
    }, _vm._l(menu.children, function (child) {
      return _c('v-list-item', {
        key: child.title,
        attrs: {
          "link": "",
          "to": child.link,
          "data-test": 'nav-link-' + child.link
        }
      }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(child.title))])], 1)], 1);
    }), 1) : _c('v-list-item', {
      key: menu.title,
      attrs: {
        "link": "",
        "to": menu.link,
        "data-test": 'nav-link-' + menu.link
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(menu.icon))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(menu.title))])], 1)], 1)];
  })], 2), _c('v-divider'), _vm.subscriptionInfo && _vm.subscriptionInfo.billed ? [_c('div', {
    staticClass: "px-4 py-3",
    attrs: {
      "data-test": "subscription-widget"
    }
  }, [_c('div', {
    staticClass: "text-subtitle-2"
  }, [_vm._v(" " + _vm._s(_vm.subscriptionInfo.planName ? "\u0414\u043E\u0441\u0442\u0443\u043F \xAB".concat(_vm.subscriptionInfo.planName, "\xBB") : 'Оплата системы') + " ")]), _vm.subscriptionInfo.balance != null ? _c('div', {
    staticClass: "text-body-2 mt-1"
  }, [_vm._v(" Баланс: "), _c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.subscriptionInfo.balance)) + " ₽")])]) : _vm._e(), _vm.subscriptionInfo.daysLeft != null ? _c('div', {
    staticClass: "text-body-2 font-weight-medium",
    class: _vm.subscriptionDaysClass,
    attrs: {
      "title": "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E \u0434\u043E ".concat(_vm.formatDate(_vm.subscriptionInfo.paidUntil))
    }
  }, [_vm._v(" " + _vm._s(_vm.subscriptionInfo.daysLeft === 0 ? 'Оплата закончилась' : "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C: ".concat(_vm.subscriptionInfo.daysLeft, " ").concat(_vm.pluralDays(_vm.subscriptionInfo.daysLeft))) + " ")]) : _vm._e()]), _c('v-divider')] : _vm._e(), false && _vm.$helper.permission.canSeeTheBilling(_vm.user) ? _c('Billing') : _vm._e(), false && _vm.$helper.permission.canSeeLawyerPlan(_vm.user) ? _c('LawyerPlan') : _vm._e(), _c('Settings')], 2), _c('v-app-bar', {
    attrs: {
      "clipped-left": _vm.primaryDrawer.clipped,
      "app": ""
    }
  }, [_c('v-app-bar-nav-icon', {
    attrs: {
      "data-test": "nav-toggle"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.primaryDrawer.model = !_vm.primaryDrawer.model;
      }
    }
  }), _c('Birthday'), _c('v-spacer'), _vm.$helper.permission.canSeeSettings(_vm.user) ? _c('v-btn', {
    attrs: {
      "to": "/settings",
      "text": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-cog-outline")])], 1) : _vm._e(), _vm.$helper.permission.canSeeNotifications(_vm.user) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.openNotifications();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-bell-outline")]), _vm._v(" Уведомления ")], 1) : _vm._e()], 1), false ? _c('NyBalls') : _vm._e(), _c('v-content', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [false ? _c('v-app-bar-nav-icon', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.primaryDrawer.model = !_vm.primaryDrawer.model;
      }
    }
  }) : _vm._e(), _c('v-progress-linear', {
    attrs: {
      "active": _vm.$store.state.loading,
      "indeterminate": true,
      "height": "4"
    }
  }), _vm.subscriptionInfo && _vm.subscriptionInfo.warn ? _c('v-alert', {
    staticClass: "mx-3 mt-3 mb-0",
    attrs: {
      "type": "warning",
      "dense": "",
      "text": "",
      "icon": "mdi-calendar-alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.subscriptionBannerText) + " ")]) : _vm._e(), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "fade"
    }
  }, [!_vm.$store.state.loading ? [_vm._t("default")] : _vm._e()], 2), _c('div', {
    staticClass: "flashpool"
  }, [_c('flash-message')], 1)], 1)], 1), _vm.$helper.permission.canSeeNotifications(_vm.user) ? _c('v-navigation-drawer', {
    staticClass: "notification-panel",
    attrs: {
      "right": "",
      "fixed": "",
      "width": "600"
    },
    model: {
      value: _vm.panels.notification.model,
      callback: function callback($$v) {
        _vm.$set(_vm.panels.notification, "model", $$v);
      },
      expression: "panels.notification.model"
    }
  }, [_c('NotificationPanel', {
    key: _vm.notificationPanelKey,
    on: {
      "closeNotificationPanel": function closeNotificationPanel($event) {
        _vm.panels.notification.model = false;
      },
      "forceUpdate": function forceUpdate($event) {
        _vm.notificationPanelKey++;
      }
    }
  })], 1) : _vm._e(), _c('v-footer', {
    attrs: {
      "inset": _vm.footer.inset,
      "app": ""
    }
  }, [_c('span', {
    staticClass: "px-4"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()))])]), _c('ScrollToTop')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }